module.exports = __webpack_public_path__ + "img/7_of_Diamonds.svg.721c774e.png";